{
  "_comment": "No weapons live here anymore (Set 20). Every weapon is a Lua plugin: the meme arsenal (shoop, poptart, doge, cat, fine, cereal, stonks, gusta, dodgeball, fish) in meme-weapons.lua, and the build tools (trowel, mallet) in tools.lua. Each registers its weapon at load into the shared table; the client rebuilds render metadata from the server's weapon manifest (see mergeServerWeapons). This file now only names the default hotbar order, so the loadout keeps its shape independent of plugin load order.",

  "defaultLoadout": ["shoop", "poptart", "doge", "cat", "fine", "cereal", "stonks", "gusta", "dodgeball", "fish", "trowel", "mallet"],

  "weapons": {}
}
